import type { QueryClient } from "@tanstack/react-query";

export type CachedQuerySnapshotType<T> = {
  queryKey: readonly unknown[];
  data: T | undefined;
};

/**
 * Finds every cached query whose key partially matches `queryKey` and returns
 * a restorable snapshot of each entry.
 */
export const captureMatchingQueries = <T>(
  queryClient: QueryClient,
  queryKey: readonly unknown[]
): Array<CachedQuerySnapshotType<T>> =>
  queryClient
    .getQueriesData<T>({ queryKey, exact: false })
    .map(([key, data]) => ({
      queryKey: key,
      data,
    }));

/** Restores query cache entries from snapshots produced by `captureMatchingQueries`. */
export const restoreMatchingQueries = <T>(
  queryClient: QueryClient,
  snapshots: Array<CachedQuerySnapshotType<T>> | undefined
) => {
  snapshots?.forEach(({ queryKey, data }) => {
    queryClient.setQueryData(queryKey, data);
  });
};
